<template>
  <div id="app"  v-cloak>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body,div,span,applet,object,iframe,h1,.h1,h2,.h2,h3,.h3,h4,.h4,h5,.h5,h6,.h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline
}
strong, b {
    font-weight: bold;
}

article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
    display: block
}

body {
    line-height: 1;
    background:#F5F5F5;
}

ol,ul {
    list-style: none
}

blockquote,q {
    quotes: none
}

blockquote:before,blockquote:after,q:before,q:after {
    content: '';
    content: none
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

*,*:before,*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box
}
body,
html,
div,
h1,
h2,
h3,
p,
span {
  color: #515151;
  font-size: 14px;
  line-height: 27px;
  font-family: -apple-system, arial, tahoma, 'Microsoft Yahei', '\5b8b\4f53', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

a,
a:hover {
  text-decoration: none;
}
input,
button {
  list-style-type: none;
}
blockquote {
  padding: 0.7em 0;
  margin: 0 0 1.66em;
  font-size: 0.7em;
  border-left: 0.41em solid #eee;
}
pre,
code {
  font-size: 0.4em;
}
.core{
    max-width:1200px;
    margin: 0 auto;
}
.topic {
    font-size: 26px;
}
.main {
  display: flex;
  padding: 32px 0 0 0;
}
.sub-main {
    flex:1;
    padding: 0 0 0 15px;
}
.left-bar {
  width: 220px;
}
.pc {
  display: block;
}
.mobile{
  display: none;
}
@media screen and (min-width:321px) and (max-width:1200px){
  .pc{
    display: none;
  }
  .mobile{
    display: block;
  }
}
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue